// ---------------------------------------------------------------------------
// Shell constants (AL-1850)
// ---------------------------------------------------------------------------
// Widths and storage keys shared by the sidebar, the rail and the topbar.
// They live apart from the components so a test can assert the contract
// without mounting the shell.
// ---------------------------------------------------------------------------

/** Expanded sidebar, as drawn in CT-0. */
export const SIDEBAR_WIDTH_PX = 280;

/** Collapsed sidebar — icons only. */
export const RAIL_WIDTH_PX = 72;

/**
 * From here up the sidebar follows the user's pinned/rail choice; below it the
 * sidebar is always the rail, phones included, so the navigation stays at the
 * side — there is no row of cards on top at any width (AL-1911). Tailwind's `lg`.
 */
export const SIDEBAR_FULL_MIN_WIDTH_PX = 1024;

/**
 * Below this (Tailwind's `sm`) there is no rail: on a phone its 72px took a
 * fifth of the screen. The sidebar opens in a drawer from the topbar instead
 * (AL-1972). From here to `lg` the rail stays as AL-1911 left it.
 */
export const SIDEBAR_DRAWER_MAX_WIDTH_PX = 640;

/**
 * Whether the sidebar is pinned open. Persisted so the choice survives a
 * navigation and a reload; the drawing has no "remember me", but a sidebar
 * that springs back open on every page is the kind of thing that gets
 * reported as a bug.
 */
export const SIDEBAR_PINNED_KEY = 'v11.shell.sidebarPinned';

/**
 * Height of the block under the collapse toggle, the same in both widths, so
 * the toggle does not jump when the sidebar opens or closes (AL-1943). Sized
 * for the rail, the taller of the two: 8px gap, help and settings stacked
 * (36 + 4 + 36), 8px gap, the 36px avatar. Expanded, the icon row and the user
 * card sit at the bottom of it and the slack falls under the toggle. Grows
 * with the rail if an icon is added to the footer.
 */
export const SIDEBAR_FOOTER_HEIGHT_PX = 128;

/** How many segments the RECENT SEGMENTS section lists. */
export const RECENT_SEGMENTS_LIMIT = 4;
